// Task 21 — contact origin tracking ("registrar cada contacto desde qué
// página está entrando"). Landing data is captured once per session; every
// lead/order submit attaches it.
const KEY = "tessa_attrib";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function captureLanding() {
  try {
    if (sessionStorage.getItem(KEY)) return;
    const params = new URLSearchParams(window.location.search);
    sessionStorage.setItem(
      KEY,
      JSON.stringify({
        landing_page: window.location.pathname,
        referrer: document.referrer || "",
        utm_source: params.get("utm_source") || "",
        utm_medium: params.get("utm_medium") || "",
        utm_campaign: params.get("utm_campaign") || "",
      })
    );
  } catch {
    /* storage unavailable — tracking is best-effort */
  }
}

// --- Task 23: interaction heatmap (pageviews + clicks per element) ----------
const queue = [];
let flushTimer = null;

function flush() {
  if (!queue.length) return;
  const events = queue.splice(0, 100);
  try {
    fetch(`${API}/analytics/interactions`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ events }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* best-effort */
  }
}

function scheduleFlush() {
  if (flushTimer) return;
  flushTimer = window.setTimeout(() => {
    flushTimer = null;
    flush();
  }, 4000);
}

export function trackPageview(path) {
  queue.push({ type: "pageview", path: path || "/" });
  scheduleFlush();
}

export function trackClick(target, kind) {
  queue.push({ type: "click", path: window.location.pathname, target, kind });
  scheduleFlush();
}

// Global listener: records clicks on any element carrying a data-testid.
// The admin panel is excluded — only visitor navigation counts.
export function startInteractionTracking() {
  document.addEventListener("click", (e) => {
    if (window.location.pathname.startsWith("/admin")) return;
    const el = e.target.closest?.("[data-testid]");
    if (el) trackClick(el.getAttribute("data-testid"), el.tagName.toLowerCase());
  });
  window.addEventListener("pagehide", flush);
}

export function getAttribution() {
  let saved = {};
  try {
    saved = JSON.parse(sessionStorage.getItem(KEY) || "{}");
  } catch {
    saved = {};
  }
  return {
    origin_page: window.location.pathname,
    landing_page: saved.landing_page || "",
    referrer: saved.referrer || "",
    utm_source: saved.utm_source || "",
    utm_medium: saved.utm_medium || "",
    utm_campaign: saved.utm_campaign || "",
  };
}
